import { render, staticRenderFns } from "./Remessa.vue?vue&type=template&id=265b68c7"
import script from "./Remessa.vue?vue&type=script&lang=js"
export * from "./Remessa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports